export class ContactDetails {
    public type: string;
    public contact: string;

    constructor(type: string, contact: string) {
        this.type = type;
        this.contact = contact;
    }
}
